// Ensure this file is treated as a module
export {};

// Extend the global Window interface
declare global {
    interface Window {
        scrollToTop: () => void,
    }
}

/**
 * Scroll the page to the top.
 *
 * Uses smooth scrolling if supported, otherwise falls back to instant jump.
 */
window.scrollToTop = () => {
    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
        window.scrollTo(0, 0);
    }
}